// extracted by mini-css-extract-plugin
export default {"card":"Form_card__OS+Hi","cardDark":"Form_cardDark__Kdhbz","inputSpacing":"Form_inputSpacing__JsGhr"};